<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen.js';
import BoConfig from '@config/BoConfig.js';
import Gen from '../helper/Gen';

export default {
  extends: Base,
  props:{
    parent: {default:()=>{ return {$route:{}}}},
    cf: {
      type: [Array, Object],
      default: () => ({})
    },
    request: Boolean,
    iframe: Boolean,
    parentTab: String
  },
  data(){
    return {
      Name: "WorkingFacility",
			PageName: "Working Facility Setup",
			ObjectName: "Working Facility",
      NoList: true,
      tabs: {id:1,activeService:""},
      mfsData: [],
      emp: {},
      fs: {},
      fsResp: [],
      oldFs: {},
      newFs: {},
      input: {},
      row: {aa:{},aal:{},haveJobtitle:false},
			mrAccessDoor: [],
			mrJobTitle: [],
			mrValidation:{
        cwid: "required|maxlength:5",
				ipin: "required",
				have_outstanding: "required",
			}
    }
  },
  computed:{
    aiStatus(){ return BoConfig.aiStatus },
    disableSetAF(){
      if(this.parent.$route.name=="AdditionalFacilityApproval") return true
      if(this.isServicesRole&&this.row.ai_type=='offboarding'&&this.row.ai_status!='SRF') return false
      return this.row.ai_status!='WFS' && !this.request
    },
    isFilled(){
      var fill = false
      this.workingFacilitiesActive().forEach(v=>{
        // if(this.row.ai_mwl_id!=4&&v.mwf_id==7) return;
        if(v.active) fill = true
      })      
      return fill
    },
    mrf_id(){
      return (this.parent.input||{}).mrf_id || this.row.ai_mrf_id
    },
    service(){
      const serviceText = this.user.al_access_module.indexOf("ITServices") > -1 ? "IT Facility" : "GA Facility";      

      if(this.user.al_access_module.indexOf("ITServices") > -1 || this.user.al_access_module.indexOf("GAServices") > -1){
        return serviceText
      } else {
        return "all"
      }
    },
    notificationLink(){
      const valueNotification = JSON.parse(this.parent.notificationLink.s_values)
      return valueNotification.notification
    },
    defaultAccessDoor(){
      return this.$parent.$parent.row.default_access_door
    },    
  },
  mounted(){
    if(this.parent.Name){
      this.setParent()
    }else{
      if(!this.iframe) this.$set(this.$root, 'page', this)
      this.loadingOverlay = true
      this.refreshData()
    }
    if(this.isServicesRole){
      Object.keys(BoConfig.mrServicesRoleWF).forEach(k=>{
        if(this.isModule(k)){
          this.tabs.activeService = BoConfig.mrServicesRoleWF[k]
          this.tabs.id = BoConfig.mrServicesRoleWF[k]
        }
      })
    } else {
      this.tabs.activeService = this.workingFacilityService() && Object.values(this.workingFacilityService()).length > 0 ? Object.values(this.workingFacilityService())[0] : "ITServices"
      this.tabs.id = this.workingFacilityService() && Object.keys(this.workingFacilityService()).length > 0 ? Object.keys(this. workingFacilityService())[0] : "1" 
    }

    const filteredWFS = Object.keys(this.workingFacilityService()).filter((k) => {
      return this.wfActive(k)
    })

    this.$set(this.tabs, 'id', +filteredWFS[0])
	},
	methods:{
    setParent(){
      this.$set(this, 'emp', this.parent.emp)
      this.$set(this, 'row', this.parent.row)

      this.$set(this, 'mfsData', this.parent.mfsData)
      
      var fs = []
      if(this.request&&this.parent.newFs.length){
        fs = this.parent.newFs
      }else if(!this.request){
        fs = this.parent.fs
      }
      this.onRefreshPage(null, {fs:fs})
    },
    refreshData(){
      BOGen.apirest("/"+this.Name+"/"+this.$route.params.id, {apc_id:this.$route.params.apc_id}, (err, resp)=>{
        this.loadingOverlay = false
        if(err) return this.$router.push({name:"Dashboard"})
        Object.keys(resp).forEach((k)=>{
          this[k] = resp[k]
        })
        if(this.$route.params.id){
          this.row.type = this.$route.params.id == "add" ? "add" : "update"
        }
        return this.onRefreshPage(err, resp)
      })
    },
    onRefreshPage(err, resp){
      this.loadingOverlay = false
      if(err) return this.$router.push({name:"Dashboard"})
      // if(this.row.ai_status=="CAF"&&this.row.ai_created_by!=this.user.cwid){
      //   return this.$router.push({name:"Dashboard"});
      // }
      if(this.row.ai_type=="additional-facility"){
        this.row.ai_mwl_id = this.emp.mwl_id
        this.row.ai_mjt_id = this.emp.mjt_id
        this.row.division = this.emp.division
        this.row.department = this.emp.department
        this.row.worklocation = this.emp.worklocation
        this.row.costcenter = this.emp.costcenter
      }else{
        if(this.emp.mjt_id) this.row.ai_mjt_id = this.emp.mjt_id
      }
      if(this.row.ai_mjt_id) this.row.haveJobtitle = true
      this.oldFs = {}
      if(resp.fs.length) resp.fs.forEach(v=>{
        this.$set(this.oldFs, v.afs_mfs_id, v)
      })
      this.fsResp = resp.fs
      if(this.row.ai_type!="onboarding"){
        this.PageName = this.row.request_for+" Detail"    
      }
      this.setFS();
      if(this.row.ai_mwl_id==4||this.emp.mwl_id==4){
        this.apiAccessDoor()
        this.apiJobTitle()
      }
      setTimeout(()=>{
        if(this.disableSetAF) $(this.$el).find(".card_working_facility").find("input,select,textarea").attr("disabled", true)
      }, 200)
      
      if(this.request){
        if(this.parent.Name) this.$set(this.parent.input, 'fs', this.fs)
      }
      if(this.iframe){
        var page = this.$root.page
        if(page.onRefreshWF) page.onRefreshWF(this)
      }
      Object.keys(this.workingFacilities()).reverse().forEach(k=>{
        if(this.wfActive(k)) this.tabs.id = k        
      })
      this.$emit("init", this)
    },
    setFS(){
      setTimeout(() => {
        this.fs = {}
        if(this.fsResp) this.fsResp.forEach(v=>{
          this.$set(this.fs, v.afs_mfs_id, v)
        })
        if(this.mrf_id != 24 || (this.mrf_id == 24 && this.row.ai_status == "APA")){
          this.mfsData.forEach((v)=>{
            var values = ""                 
            if(v.mfs_type=='checkbox') values = []
            if(v.mfs_type=='checkbox_title') values = []
            if(v.mfs_type=='mobile_device') values = {brand:'',simcard:'micro'}
            if(v.mfs_type=='bit') values = false
            if(v.mfs_type=='sharefolder') values = [{access:'read'}]
            if(v.mfs_default) values = v.mfs_default
            if(v.mfs_name.toLowerCase().includes('access') && this.defaultAccessDoor.length > 0){
              values = [
                { title: "Access Door", options: this.defaultAccessDoor, title: 'Access Door' }
              ]
            }

            if(!this.fs[v.mfs_id]) {
              this.$set(this.fs, v.mfs_id, {
                afs_mfs_id:v.mfs_id,
                afs_answer: values,
                afs_remarks:"",
                afs_id: this.parent.fs.find(x => x.afs_mfs_id == v.mfs_id) == undefined ? null : this.parent.fs.find(x => x.afs_mfs_id == v.mfs_id).afs_id,
                afs_attachment: v.mfs_facility_need_attachment ? v.mfs_facility_need_attachment.map(facility => ({name: facility, file: ""})) : [],
                afs_type: v.mfs_type
              })
            } 
          })
        } else {
          // this.mfsData.filter(x => { 
          //   if(this.row.ai_mrf_id == 24 && this.service != 'all'){
          //     return x.mwf_name == this.service
          //   } else {
          //     return true
          //   }
          // })
          this.mfsData.forEach((v)=>{
            var values = ""
            if(v.mfs_type=='checkbox') values = []
            if(v.mfs_type=='checkbox_title') values = []
            if(v.mfs_type=='mobile_device') values = {brand:'',simcard:'micro'}
            if(v.mfs_type=='bit') values = false
            if(v.mfs_type=='sharefolder') values = [{access:'read'}]
            if(v.mfs_default) values = v.mfs_default
            if(!this.fs[v.mfs_id]) {              
              this.$set(this.fs, v.mfs_id, {
                afs_mfs_id: v.mfs_id,
                // afs_answer: this.parent.fs.find(x => x.afs_mfs_id == v.mfs_id) == undefined ? values : this.parent.fs.find(x => x.afs_mfs_id == v.mfs_id).afs_answer,
                afs_answer: this.cf[v.mfs_id] == undefined ? values : this.cf[v.mfs_id].afs_answer,
                afs_remarks:"",                
                // afs_id: this.parent.fs.find(x => x.afs_mfs_id == v.mfs_id) == undefined ? values : this.parent.fs.find(x => x.afs_mfs_id == v.mfs_id).afs_id,
                afs_id: this.cf[v.mfs_id] == undefined ? values : this.cf[v.mfs_id].afs_id,
                afs_attachment: v.mfs_facility_need_attachment ? v.mfs_facility_need_attachment.map(facility => ({name: facility, file: ""})) : [],
                afs_type: v.mfs_type
              })          
            }
          })       
        }
      }, 1500)
    },
		apiAccessDoor(){
			BOGen.apirest("/access-door-select", {}, (e,resp)=>{
				if(e) return console.error(e)
				this.mrAccessDoor = resp.data
			})
		},
		apiJobTitle(){
			BOGen.apirest("/job-title-select", {}, (e,resp)=>{
				if(e) return console.error(e)
				this.mrJobTitle = resp.data
			})
		},
    isHeading(v){
      if(this.heading==v.mfs_heading) return ""
      this.heading = v.mfs_heading
      return v.mfs_heading
    },
    isGroup(v){
      if(this.group==v.mfs_group) return ""
      this.group = v.mfs_group
      return v.mfs_group
    },
    wfActive(id){      
      if(this.mrf_id==25 || this.mrf_id == 24){
        var show = false
        this.mfsData.filter(x => { 
          if(this.row.ai_mrf_id == 24 && this.service != 'all'){
            return x.mwf_name == this.service
          } else {
            return true
          }
        }).filter(x=>{ return x.mfs_mwf_id == id }).forEach(v=>{
          if(this.isLend(v)) show = true
        })
        return show
      }
      const checkAdditionalFacility = this.mfsData.filter(facility => {
        return facility.mfs_mwf_id == id && !facility.mfs_is_lend && facility.status
      })

      if(checkAdditionalFacility.length <= 0) return false
      if(this.$route.name == "StatusReportDetail") return true
      if(this.row.ai_status=="DONE"&&this.$route.name=="WorkingFacilityConfirmation"){
        return (this.workingFacilitiesActive().filter(v=>{return v.mwf_id==id})[0]||{}).active
      }
      if(this.row.ai_status=="CAF") return true
      if(!this.request&&this.isModule("HRServices")) return true
      if(["SRF"].indexOf(this.row.ai_status)>-1||
        (this.request&&this.mrf_id==24) ||
        (this.row.ai_type=="offboarding"&&this.isServicesRole)
      ){
        if(this.isModule(BoConfig.mrHRServices)) return id == 4
        return this.tabs.activeService == id
      }
      return true
    },
    isLend(v){
      if((this.mrf_id==23 || this.mrf_id==32) && v.mfs_is_lend) return false
      if((this.mrf_id==23 || this.mrf_id==32) && !v.mfs_is_lend) return true
      if((this.mrf_id==25) && !v.mfs_is_lend) return false
      if((this.mrf_id==25) && v.mfs_is_lend) return true
      return true
    },
		workingFacilities(){
      var data = {}
      if(typeof this.mfsData == "undefined") return {}            
			this.mfsData.filter(x => { 
          if(this.row.ai_mrf_id == 24 && this.service != 'all'){
            return x.mwf_name == this.service
          } else {
            return true
          }
        }).forEach((v)=>{                  
        if(!data[v.mfs_mwf_id]) data[v.mfs_mwf_id] = v.mwf_name
			})        
			return data
    },    
    workingFacilitiesActive(){
      var data = []      
      Object.keys(this.workingFacilities()).forEach(mwf_id=>{
        var active = false
        this.mfsData.filter(x => { 
          // if(this.row.ai_mrf_id == 24 && this.service != 'all'){
          //   return x.mwf_name == this.service
          // } else {
          //   return true
          // }
          return true
        }).filter(x=>{ return x.mfs_mwf_id == mwf_id }).forEach(v=>{          
          if(this.fs[v.mfs_id] && typeof this.fs[v.mfs_id].afs_answer == "object"){            
            if(v.mfs_type == "checkbox"){
              if(this.fs[v.mfs_id] && this.fs[v.mfs_id].afs_answer.length) active = true
            }

            if(v.mfs_type == "checkbox_title"){
              if(this.fs[v.mfs_id] && this.fs[v.mfs_id].afs_answer.map(x => x.options).flat(Infinity).length) active = true
            }
          }
        })
        data.push({mwf_id:mwf_id,module:Gen.getKeyByValue(BoConfig.mrServicesRoleWF,mwf_id),active:active})
      })
      return data;
    },
    fsDiff(){
      return BOGen.fsDiff(this, this.oldFs, this.fs)
    },
		resultDataEmployee(data) {
			var items = [];
			data.data.forEach((x)=>{
				items.push({
					id: x.employeeno,
					text: (x.cwid?x.cwid+" | ":"")+x.employeename+" "+(x.position?"("+x.position+")":""),
				})
			})
			return {results: items}
		},
    submitForm(e){
      if(['DONE','REJECT'].indexOf(this.row.ai_status)>-1) return;
      swal({
        title: "Are you sure to submit?",
        text:"",
        icon: "warning",
        buttons: ["No, Cancel!", "Yes, Sure!"],
        // dangerMode: true,
      }).then((ok) => {
        if (!ok) return
        if(this.loadingOverlay) return;
        this.loadingOverlay = true

        if(this.row.ai_status=="CAF"){
          this.input.request_number = this.row.ai_request_number
          this.input.workingFacilitiesActive = this.workingFacilitiesActive()
          this.input.fsDiff = this.fsDiff()
          BOGen.apirest("/AdditionalFacilityConfirmation", this.input, (err, resp)=>{
            this.loadingOverlay = false
            if(err) return console.error(err)
            swal("Data has been submitted", "", "success").then(()=>{
              this.$router.push({name:"Inbox"})
              this.input = {}
              $("body,html").animate({scrollTop:0}, 300)
            })
          }, "POST")
        }else if(this.row.ai_status == "WFS"){
          var fs = [];
          Object.keys(this.fs).forEach(v=>{
            var afs = Gen.clone(this.fs[v])
            afs.afs_answer = JSON.stringify(afs.afs_answer)
            fs.push(afs)
          })
          var params = Gen.clone({
            ai_request_number: this.row.ai_request_number,
            fs: fs,
          });
          if(this.row.ai_mjt_id) params.ai_mjt_id = this.row.ai_mjt_id
          BOGen.apirest("/WorkingFacilitySetup", params, (err, resp)=>{
            this.loadingOverlay = false
            if(err){
              if(err.json.message) return Gen.info(err.json.message, "danger", 3000, ".infoRemarks")
              return console.error(err)
            }
            swal("Data has been submitted", "", "success").then(()=>{
              this.$router.push({name:"Inbox"})
            })
          }, "POST");
        }else if(this.isServicesRole&&this.row.ai_type=="offboarding"&&this.row.ai_wf_status=="OR"){
          var fs = [];
          Object.keys(this.fs).forEach(v=>{
            var afs = Gen.clone(this.fs[v])
            afs.afs_answer = JSON.stringify(afs.afs_answer)
            fs.push(afs)
          })
          this.input.fs = fs
          BOGen.apirest("/ConfirmOutstanding", Gen.clone(Object.assign({
            request_number: this.row.ai_request_number,
          },this.input)), (err, resp)=>{
            this.loadingOverlay = false
            if(err){
              if(err.json.message) return Gen.info(err.json.message, "danger", 3000, ".infoRemarks")
              return console.error(err)
            }
            swal("Data has been submitted", "", "success").then(()=>{
              this.$router.push({name:"Inbox"})
            })
          }, "POST");
        }else if(this.isServicesRole&&this.row.ai_status=="SRF"){
          this.input.workingFacilitiesActive = this.workingFacilitiesActive()
          var fs = [];
          Object.keys(this.fs).forEach(v=>{
            var afs = Gen.clone(this.fs[v])
            afs.afs_answer = JSON.stringify(afs.afs_answer)
            fs.push(afs)
          })
          this.input.fs = fs
          BOGen.apirest("/RelatedWorkingFacility", Gen.clone(Object.assign({
            request_number: this.row.ai_request_number,
          },this.input)), (err, resp)=>{
            this.loadingOverlay = false
            if(err){
              if(err.json.message) return Gen.info(err.json.message, "danger", 3000, ".infoRemarks")
              return console.error(err)
            }
            swal("Data has been submitted", "", "success").then(()=>{
              this.$router.push({name:"Inbox"})
            })
          }, "POST");
        }
      });
    },
    afss(id){
      return this.row.afssGet.filter(v=>{ return BoConfig.mrServicesRoleWF[v.afss_type] == id })[0] || {}
    },
    afssOutstadingRemarks(id){
      if(id==4){
        var remarks = [];
        this.row.afssGet.filter(v=>{ return ["HRLeave","HRCB","HRSeparation"].indexOf(v.afss_type)>-1 }).forEach((v,k)=>{
          if(!v.afss_outstanding_remarks) return;
          var role = BoConfig.mrAccessModule[v.afss_type]
          remarks.push("<b>"+role+"</b> :<br>"+v.afss_outstanding_remarks)
        })
        return remarks.join("<br><br>")
      }
      return this.afss(id).afss_outstanding_remarks
    },
    workingFacilityService(){
      if(this.user.al_name == "Administrator") return this.workingFacilities()
      if(this.$route.name == "AdditionalFacilityInit") return this.workingFacilities()
      if(this.user.al_access_module.indexOf("ITServices") > -1){
        return {1 : this.workingFacilities()["1"] }
      } else if (this.user.al_access_module.indexOf("GAServices") > -1) {
        return {7: this.workingFacilities()["7"] }
      } else {                
        return this.workingFacilities()
      }
    },
    checkFacility(type, is_dept_operation, facilityOperation, data){            
      if(!is_dept_operation && facilityOperation){   
        if(type == "checkbox") {
          return data.length == facilityOperation.length      
        } else {
          const checked = data.map(x => facilityOperation.indexOf(x) > -1)

          return checked.indexOf(false) > -1
        }
      } else {
        return true
      }
    },
    checkFacilityNeedAttachment(facilities, type, data){      
      if(data.mfs_facility_need_attachment){   
        if(type == 'checkbox_title'){
          if(!facilities) return false
          const optionsSelected = facilities.map(facility => facility.options).flat(Infinity)
          const mapOptionsSelected = optionsSelected.map(option => data.mfs_facility_need_attachment.indexOf(option) >= 0 ? true : false)
  
          if (mapOptionsSelected.indexOf(true) >= 0) return true
        }
  
        if(type == 'checkbox') {
          if(!facilities) return false
          
          const mapOptionsSelected = facilities.map(facility => data.mfs_facility_need_attachment.indexOf(facility) >= 0 ? true : false)
          if (mapOptionsSelected.indexOf(true) >= 0) return true
        }
      }

      return false
    },
    checkFacilityNeedAttachmentSelected(facilities, facilityName, data){
      if(data.mfs_facility_need_attachment){
        if(data.mfs_type == 'checkbox_title'){
          const optionsSelected = facilities.map(facility => facility.options).flat(Infinity)
          const findOption = optionsSelected.find(option => option == facilityName)
  
          if (findOption) return true
        }
        if(data.mfs_type == 'checkbox') {
          const findOption = facilities.find(facility => facility == facilityName)
          if (findOption) return true
        }
      }

      return false
    },
    changeLink2Anchor(text) {
      const regex = /(https?:\/\/[^\s]+)/g;
      const links = text.match(regex);

      let replacedText = text
      links.forEach(link => {
        replacedText = replacedText.replace(link, `<a href="${link}" target="_blank" class="notif-link">${link}</a>`)
      })
      
      return replacedText
    },
    checkDefaultAccessDoor(name){
      if(!this.defaultAccessDoor.length) return false
      return this.defaultAccessDoor.indexOf(name) >= 0
    },
	},
  watch:{
    '$route.query'(){
			this.refreshData()
    },
    'parentTab'(){
      setTimeout(()=>{
        if(this.disableSetAF) $(this.$el).find(".card_working_facility").find("input,select,textarea").attr("disabled", true)
      }, 0)
    },
    'mrf_id'(){
      const filteredWFS = Object.keys(this.workingFacilityService()).filter((k) => {
        return this.wfActive(k)
      })

      this.$set(this.tabs, 'id', +filteredWFS[0])      
    }
  }
}
</script>

<style scoped>
.notif-it-facility{
  padding: 2.3em;
  font-weight: 600;
}

.notif-it-facility a.notif-link{
  text-decoration: underline !important;
}
</style>

<template>  
	<div :class="{'container-fluid':!iframe&&!parent.Name}">    
		<PageTitle v-if="!iframe&&!parent.Name"></PageTitle>
		<VForm @resp="submitForm" method="post">
      <div class="card" v-if="!iframe&&!parent.Name">
        <div class="card-header bg-info">
          <h4 class="m-b-0 text-white">{{row.ai_type=='onboarding'?'Authorization':'Employee Information'}}</h4>
        </div>
        <div class="table-responsive">
          <table class="table table-striped m-b-0 tdl20">
            <tbody>
              <tr>
                <td><b>Request No</b>
                  <p><span class="label label-table label-success">{{row.ai_request_number}}</span></p>
                </td>
                <td><b>Request Date</b>
                  <p>{{ (row.ai_created_at||'').dates('format2') }}</p>
                </td>
                <td><b>Request For</b>
                  <p>{{ row.request_for }}</p>
                </td>
              </tr>
              <tr>
                <td><b>Employee Name</b>
                  <p>{{ row.employeename || emp.employeename || "-" }}</p>
                </td>
                <td><b>Employee No</b>
                  <p>{{ emp.employeeno || "-" }}</p>
                </td>
                <td><b>IPIN No</b>
                  <p>{{ row.ai_ipin || emp.IPIN || "-" }}</p>
                </td>
              </tr>
              <tr>
                <td><b>Division</b>
                  <p>{{ row.ai_division || emp.division || "-" }}</p>
                </td>
                <td><b>Department</b>
                  <p>{{ row.ai_department || emp.department || "-" }}</p>
                </td>
                <td><b>Cost Center SAP</b>
                  <p>{{ row.ai_costcenter || emp.costcenter || "-" }}</p>
                </td>
              </tr>
              <tr>
                <td><b>Work Location</b>
                  <p>{{ row.ai_worklocation || emp.worklocation || "-" }}</p>
                </td>
                <td colspan="2">
                  <template v-if="isModule('HROPS')">
                    <b>Job Title</b>
                    <p>{{ emp.jobtitle || "-" }}</p>
                  </template>
                </td>
              </tr>
              <tr v-if="row.aal.aal_remarks&&$route.name!='StatusReportDetail'">
                <td colspan="3"><b>Remarks</b>
                  <p>{{ row.aal.aal_remarks }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
		  </div>

      <div class="card card_working_facility" :class="{iframe:iframe}">
        <div class="card-body p-b-0" v-if="!iframe">
          <h4 class="card-title">Working Facility</h4>          
        </div>
        <!-- Nav tabs -->
        <ul class="nav nav-tabs customtab" role="tablist">
          <li class="nav-item" v-for="(v,k) in workingFacilityService()" :key="k" v-show="wfActive(k)">
            <a class="nav-link" :class="{active:k==tabs.id}" data-toggle="tab" @click="tabs.id=k" href="javascript:;">
              <span>{{v}}</span>
            </a>
          </li>
        </ul>
        <!-- debug -->
        <section v-for="(mwf_name,mwf_id) in workingFacilities()" :key="mwf_id" v-show="tabs.id==mwf_id" :class="'wf_'+mwf_id">          
          <template v-if="$route.name!='StatusReportDetail'">
            <div class="services_remarks" v-if="afss(mwf_id).afss_remarks&&!request">
              <table>
                <tr>
                  <td>Remarks : </td>
                  <td><b>{{afss(mwf_id).afss_remarks||"-"}}</b></td>
                </tr>
              </table>
            </div>
            <div class="outstanding_remarks" v-if="afssOutstadingRemarks(mwf_id)">
              <table>
                <tr>
                  <td>Remarks Outstanding :</td>
                  <td style="padding-left: 20px" v-html="afssOutstadingRemarks(mwf_id)||'-'"></td>
                </tr>
              </table>
            </div>
          </template>          
          <template v-for="(v,k) in mfsData.filter(x=>{ return x.mfs_mwf_id == mwf_id }).filter(x => {
              if(row.ai_mrf_id == 24 && status != 'all'){
                return x.mwf_name == service
              } else {
                return x.mwf_name
              }
            })">
            <div :key="k" :class="'fs_'+v.mfs_type+' fs_'+v.mfs_id" v-if="isLend(v)">
              <table class="table table-striped" v-if="isHeading(v)">
                <thead class="heading"><tr><th style="font-size:16px;">{{v.mfs_heading}}</th></tr></thead>
              </table>
              <div class="wrap_fs mt-2" v-if="isGroup(v)"><h5><b>{{v.mfs_group}}</b></h5></div>
              <div v-if="v.mfs_type=='checkbox'" class="wrap_fs mt-4">                
                <template v-if="!parentTab || parentTab =='current' || ($route.name != 'AdditionalFacilityInit' && $route.name != 'AdditionalFacilityApproval')">
                  <h5><b>{{v.mfs_name}}</b></h5>
                  <div class="row">
                    <div class="col-sm-4" v-if="fs[v.mfs_id]">
                      <Checkbox 
                        v-model="(fs[v.mfs_id]||{}).afs_answer" 
                        :option="{value: v2, facility_operation: v.mfs_facility_operation, dept_is_operation: emp.is_department_operation}" 
                        :array="true" 
                        v-for="(v2,k2) in v.mfs_values" 
                        :key="k2"
                      >{{v2}}</Checkbox>
                    </div>
                    <div class="col-sm-6">
                      <textarea v-if="v.mfs_with_remarks" v-model="(fs[v.mfs_id]||{}).afs_remarks" rows="3" class="form-control" placeholder="Remarks"></textarea>                                                                  
                      <template v-if="checkFacilityNeedAttachment((fs[v.mfs_id]||{}).afs_answer, v.mfs_type, v) && (!row.ai_status || row.ai_status == 'ADC')">
                        <h4 class="font-weight-bold mb-3 mt-3">Attachment</h4>
                        <div class="row">
                          <template v-for="(attachment, kattachment) in v.mfs_facility_need_attachment">
                            <div class="col-md-6 mb-3" :key="kattachment" v-if="checkFacilityNeedAttachmentSelected((fs[v.mfs_id]||{}).afs_answer, attachment, v)">
                              <BoField :label="attachment" :attr="{required: true}">
                                <Uploader :name="'attachment_'+kattachment" path="docs" v-model="fs[v.mfs_id].afs_attachment[kattachment].file" accept=".pdf,.jpg,.jpeg,.png" mandatory :isDisable="row.ai_id != 0 && true"></Uploader>
                              </BoField>
                            </div>
                          </template>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>

                <div class="row" v-if="parentTab && parentTab == 'old' && ($route.name == 'AdditionalFacilityApproval' || $route.name == 'AdditionalFacilityInit')">
                  <div class="col-md-7 mb-4">
                    <h5 class="mb-0"><strong>{{ v.mfs_name }}</strong></h5>                    
                    <div class="facilities" v-if="cf[v.mfs_id] && cf[v.mfs_id].afs_answer.length > 0">
                      <div class="facility-item mr-2" v-for="(item, k) in cf[v.mfs_id].afs_answer" :key="k">
                        <i class="icon-check"></i>
                        <span>{{ item }}</span>
                      </div>
                    </div>
                    <div class="facilities" v-else>
                      <p>No Items Selected</p>
                    </div>
                    <template v-if="v.mfs_with_remarks && v.mfs_with_remarks.length > 1">
                      <strong>Remarks</strong>
                      <p>{{ cf[v.mfs_id].afs_remarks }}</p>
                    </template>
                  </div>
                </div>
              </div>
              <div v-if="v.mfs_type=='checkbox_title'" class="wrap_fs">
                <hr>
                <h5><b>{{v.mfs_name}}</b></h5>
                <hr>
                <div class="row" v-for="(value, key) in v.mfs_values" :key="`parent-${key}`">
                  <template v-if="!parentTab || parentTab =='current' || ($route.name != 'AdditionalFacilityInit' && $route.name != 'AdditionalFacilityApproval')">
                    <div class="col-sm-12">
                      <h6 class="mb0 mt-2">{{ value.title }}</h6>
                    </div>
                    <div class="col-sm-4" v-if="fs[v.mfs_id]">
                      <Checkbox 
                        v-model="(fs[v.mfs_id]||{}).afs_answer" 
                        :option="{title: value.title, value: v2, facility_operation: v.mfs_facility_operation, dept_is_operation: emp.is_department_operation}" :array="true" 
                        :isArrayOfObjects="true" v-for="(v2,k2) in value.options" 
                        :key="k2"
                        :arrayOfObjects="v.mfs_values"
                        :attr="checkDefaultAccessDoor(v2) ? { disabled: true } : {}"
                        :defaultAccessDoor="defaultAccessDoor"
                      >{{v2}}</Checkbox>

                      <p v-html="changeLink2Anchor(value.link)" v-if="value.link"></p>
                    </div>
                    <div class="col-sm-6">
                      <textarea v-if="v.mfs_with_remarks && key == 0" v-model="(fs[v.mfs_id]||{}).afs_remarks" rows="3" class="form-control" placeholder="Remarks"></textarea>

                      <!-- Upload File for fafcility need attachment -->                      
                      <template v-if="checkFacilityNeedAttachment((fs[v.mfs_id]||{}).afs_answer, v.mfs_type, v) && key == 0 && (!row.ai_status || row.ai_status == 'ADC')">
                        <h4 class="font-weight-bold mb-3 mt-3">Attachment</h4>
                        <div class="row">
                          <template v-for="(attachment, kattachment) in v.mfs_facility_need_attachment">
                            <div class="col-md-6 mb-3" :key="kattachment" v-if="checkFacilityNeedAttachmentSelected((fs[v.mfs_id]||{}).afs_answer, attachment, v)">
                              <BoField :label="attachment" :attr="{required: true}">
                                <Uploader :name="'attachment_'+kattachment" path="docs" v-model="fs[v.mfs_id].afs_attachment[kattachment].file" accept=".pdf,.jpg,.jpeg,.png" mandatory :isDisable="row.ai_id != 0 && true"></Uploader>
                              </BoField>
                            </div>
                          </template>
                        </div>
                      </template>
                    </div>
                  </template>
                  <template v-if="parentTab && parentTab == 'old' && ($route.name == 'AdditionalFacilityApproval' || $route.name == 'AdditionalFacilityInit')">
                    <div class="col-md-7 mb-4">
                      <h6 class="mb-0" style="font-weight: 500;"><strong>{{ value.title }}</strong></h6>
                      <div class="facilities mr-2">
                        <template v-if="cf[v.mfs_id] && cf[v.mfs_id].afs_answer.find(x => x.title == value.title)">
                          <template v-if="cf[v.mfs_id] && cf[v.mfs_id].afs_answer.find(x => x.title == value.title).options">

                            <div class="facility-item" v-for="(x, k3) in cf[v.mfs_id].afs_answer.find(x => x.title == value.title).options" :key="k3">
                              <i class="icon-check"></i>
                              <span>{{ x }}</span>
                            </div>
                          </template>

                          <template v-else>
                            <p>No Items Selected</p>
                          </template>
                        </template>

                        <template v-else>
                          <p>No Items Selected</p>
                        </template>                        
                      </div>
                      <template v-if="v.mfs_with_remarks && v.mfs_with_remarks.length > 1">
                        <strong>Remarks</strong>
                        <p>{{ cf[v.mfs_id].afs_remarks }}</p>
                      </template>

                    </div>
                  </template>
                </div>
              </div>
              <div v-if="v.mfs_type=='bit'" class="wrap_fs">
                <div class="row">
                  <div class="col-sm-3">
                    <Checkbox v-model="(fs[v.mfs_id]||{}).afs_answer" v-if="fs[v.mfs_id]">{{v.mfs_name}}</Checkbox>
                  </div>
                  <div class="col-sm-6" v-if="v.mfs_with_remarks">
                    <textarea v-model="(fs[v.mfs_id]||{}).afs_remarks" rows="2" class="form-control" placeholder="Remarks"></textarea>
                  </div>
                </div>
              </div>
              <div v-if="v.mfs_type=='textfield'" class="wrap_fs">
                <div class="row">
                  <div class="col-sm-3">{{v.mfs_name}}</div>
                  <div class="col-sm-6">
                    <input type="text" v-model="(fs[v.mfs_id]||{}).afs_answer" class="form-control" :placeholder="v.mfs_name" v-if="fs[v.mfs_id]">
                  </div>
                </div>
              </div>
              <div v-if="v.mfs_type=='currency'" class="wrap_fs">
                <div class="row">
                  <div class="col-sm-3">{{v.mfs_name}}</div>
                  <div class="col-sm-6">
                    <div class="input-group">
                      <div class="input-group-prepend"><span class="input-group-text">IDR</span></div>
                      <Currency v-model="(fs[v.mfs_id]||{}).afs_answer" class="form-control" :placeholder="v.mfs_name" v-if="fs[v.mfs_id]"></Currency>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="v.mfs_type=='dropdown'" class="wrap_fs">
                <div class="row">
                  <div class="col-sm-3">{{v.mfs_name}}</div>
                  <div class="col-sm-6">
                    <Select2 v-model="(fs[v.mfs_id]||{}).afs_answer">
                      <option value="">-- Select One --</option>
                      <option v-for="(v2,k2) in v.mfs_values" :key="k2" :value="v2">{{v2}}</option>
                    </Select2>
                  </div>
                </div>
              </div>
              <div v-if="v.mfs_type=='sharefolder'" class="wrap_fs">
                <h5><b>{{v.mfs_name}}</b></h5>
                <div v-if="!disableSetAF">
                  <div v-for="(v2,k2) in (fs[v.mfs_id]||{}).afs_answer" :key="k2" class="row">
                    <div class="col-sm-5">
                      <div class="form-group">
                        <input type="text" v-model="v2.foldername" class="form-control" placeholder="Folder Name">
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <Select2 url="/bussiness-group-select" v-model="v2.bg_id" :object="['mbg_bg_id','mbg_bussiness_group']">
                              <option value="">-- Select Division --</option>
                            </Select2>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <Select2 url="/work-location-select" :object="['mwl_id','mwl_name']" v-model="v2.mwl_id">
                              <option value="">-- Site --</option>
                            </Select2>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-8">
                          <div class="form-group">
                            <Select2 url="/department-select" :filter="'x.msg_bg_id=='+v2.bg_id" :object="['msg_id','msg_name']" v-model="v2.msg_id">
                              <option value="">-- Select Department --</option>
                            </Select2>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <Select2 :options="{read:'Read',write:'Write',full:'Full'}" v-model="v2.access"></Select2>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <Select2Ajax url="/api/employees-select" v-model="v2.owner" :resultData="resultDataEmployee" placeholder="-- Owner --"></Select2Ajax>
                      </div>
                      <div class="form-group">
                        <textarea v-model="v2.remarks" rows="3" class="form-control" placeholder="Remarks"></textarea>
                      </div>
                    </div>
                    <div class="col-sm-1">
                      <button type="button" v-tooltip="'Add'" @click="addSharefolder(v.mfs_id)" class="btn btn-success btn-sm btn-circle btn-block"><i class="fa fa-plus"></i></button>
                      <button type="button" v-tooltip="'Remove'" @click="removeSharefolder(v.mfs_id, k2)" class="btn btn-danger btn-sm btn-circle btn-block"><i class="fa fa-times"></i></button>
                    </div>
                    <div class="col-sm-12"><hr></div>
                  </div>
                </div>
                <div class="table-responsive table_sharefolder" v-if="disableSetAF">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Folder Name</th>
                        <th>Division</th>
                        <th>Site</th>
                        <th>Department</th>
                        <th>Access</th>
                        <th>Owner</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(v2,k2) in sharefolderVal((fs[v.mfs_id]||{}).afs_answer)" :key="k2">
                        <td>{{v2.foldername}}</td>
                        <td>
                          <Select2 url="/bussiness-group-select" v-model="v2.bg_id" :object="['mbg_bg_id','mbg_bussiness_group']"></Select2>
                        </td>
                        <td>
                          <Select2 url="/work-location-select" :object="['mwl_id','mwl_name']" v-model="v2.mwl_id"></Select2>
                        </td>
                        <td>
                          <Select2 url="/department-select" :object="['msg_id','msg_name']" v-model="v2.msg_id"></Select2>
                        </td>
                        <td>
                          <Select2 :options="{read:'Read',write:'Write',full:'Full'}" v-model="v2.access"></Select2>
                        </td>
                        <td>
                          <Select2Ajax url="/api/employees-select" v-model="v2.owner" :resultData="resultDataEmployee"></Select2Ajax>
                        </td>
                        <td>{{v2.remarks}}</td>
                      </tr>
                      <tr v-if="!sharefolderVal((fs[v.mfs_id]||{}).afs_answer).length">
                        <td colspan="8" class="tc">{{v.mfs_name}} is empty</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-if="v.mfs_type=='access_door'" class="wrap_fs">
                <div class="row form-group">
                  <div class="col-sm-2">Job Title</div>
                  <div class="col-sm-4">
                    <Select2 v-model="row.ai_mjt_id" :options="mrJobTitle" :object="['mjt_id','mjt_name']" :disabled="row.haveJobtitle">
                      <option value="">-- Select Job Title --</option>
                    </Select2>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-sm-2">{{v.mfs_name}}</div>
                  <div class="col-sm-10" v-if="fs[v.mfs_id]">
                    <Checkbox v-model="(fs[v.mfs_id]||{}).afs_answer" :option="v2.mad_id" :array="true" v-for="(v2,k2) in mrAccessDoor" :key="k2" style="width: 250px">{{v2.mad_name}}</Checkbox>
                  </div>
                </div>
              </div>
              <div v-if="v.mfs_type=='heading'" class="wrap_fs">
                <h4><b>{{v.mfs_name}}</b></h4>
              </div>
            </div>
          </template>

          <!-- IT Facilty Show Notificaton Link -->
          <!-- <div class="row" v-if="tabs.id == 1">
            <div class="col-md-12 notif-it-facility">
              <h4 class="font-weight-bold">Note: </h4>
                <div class="alert alert-info sm" role="alert">                  
                  <span v-html="notificationLink"></span>
                </div>
            </div>
          </div> -->
        </section>
		  </div>
      <!-- <div class="card" v-if="row.ai_status=='CAF'"> -->
      <div class="card" v-if="row.ai_status=='CAF' && row.ai_created_by==user.cwid">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Remarks <small class="txt_mandatory">*</small></label>
                <textarea name="remarks" class="form-control" v-model="input.remarks" rows="5" required></textarea>
              </div>
            </div>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn-info mr10" @click="input.status='A'">
               <span>Confirm that all facility is received</span>
            </button>
            <button type="submit" class="btn btn-danger" @click="input.status='R'">Reject</button>
          </div>
        </div>
      </div>
      <div class="card" v-else-if="!iframe&&!parent.Name&&['DONE','REJECT'].indexOf(this.row.ai_status)==-1&&$route.name!='StatusReportDetail'">
        <div class="card-body">
          <div class="infoRemarks"></div>
          <div class="row" v-if="isModule('SetIPIN')&&['onboarding','movement'].indexOf(row.ai_type)>-1">
            <div class="col-md-2">
              <div class="form-group">
                <label>CWID <small class="txt_mandatory">*</small></label>
                <input type="text" name="cwid" class="form-control" v-model="input.cwid" v-bind="validation('cwid')" autocomplete="off">
              </div>
              <div class="form-group">
                <label>IPIN <small class="txt_mandatory">*</small></label>
                <input type="number" name="ipin" class="form-control" v-model="input.ipin" v-bind="validation('ipin')" autocomplete="off">
              </div>
            </div>
          </div>
          <div class="row" v-if="isServicesRole&&row.ai_type=='offboarding'&&row.ai_status!='SRF'">
            <div class="col-md-6">
              <BoField name="have_outstanding">
                <Select2 name="have_outstanding" v-model="input.have_outstanding" v-bind="validation('have_outstanding')">
                  <option value="">-- Select --</option>
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </Select2>
              </BoField>
            </div>
            <div class="col-md-6"></div>
            <div class="col-md-6" v-if="input.have_outstanding=='Y'">
              <div class="form-group">
                <label>Remarks <span>Outstanding</span><small class="txt_mandatory">*</small></label>
                <textarea name="remarks" class="form-control" v-model="input.remarks" rows="5" required></textarea>
              </div>
            </div>
          </div>
          <div class="row" v-else-if="isServicesRole">
            <div class="col-md-6">
              <div class="form-group">
                <label>Remarks<small class="txt_mandatory">*</small></label>
                <textarea name="remarks" class="form-control" v-model="input.remarks" rows="5" required></textarea>
              </div>
            </div>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn-info btn-loading">
              <span v-if="isServicesRole">Confirm</span>
              <span v-else>Submit All Facility Items</span>
            </button>
          </div>
        </div>
      </div>
    </VForm>
	</div>
</template>